/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { switch_destination_id } from '../models/switch_destination_id';
import type { SwitchesDestinationsListRequest } from '../models/SwitchesDestinationsListRequest';
import type { SwitchesDestinationsListResponse } from '../models/SwitchesDestinationsListResponse';
import type { SwitchesDestinationsPostRequest } from '../models/SwitchesDestinationsPostRequest';
import type { SwitchesDestinationsPostResponse } from '../models/SwitchesDestinationsPostResponse';
import type { SwitchesDestinationsPutRequest } from '../models/SwitchesDestinationsPutRequest';
import type { SwithesDestinationsGetResponse } from '../models/SwithesDestinationsGetResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class SwitchesDestinationsService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Create a Switch Destination linked to a contract
     * Create a Switch Destination linked to a contract. It linked the destination to all the sources of the contract (Access: admin)
     * @returns SwitchesDestinationsPostResponse Switches list
     * @returns any Unexpected error
     * @throws ApiError
     */
    public createDestination({
        requestBody,
    }: {
        requestBody: SwitchesDestinationsPostRequest,
    }): CancelablePromise<SwitchesDestinationsPostResponse | {
        code: number;
        message: string;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/switches/destinations',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Access token is missing or invalid`,
                415: `Unsupported Media Type`,
            },
        });
    }
    /**
     * Get a Switch Destination
     * Returns a SwitchDdestination based on a single ID (Access: admin)
     * @returns SwithesDestinationsGetResponse Switch Destination's information
     * @returns any Unexpected error
     * @throws ApiError
     */
    public getSwitchDestinationById({
        id,
    }: {
        /**
         * ID of the Switch Destination to fetch
         */
        id: switch_destination_id,
    }): CancelablePromise<SwithesDestinationsGetResponse | {
        code: number;
        message: string;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/switches/destinations/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Access token is missing or invalid`,
                404: `Not found`,
            },
        });
    }
    /**
     * Update a Switch Destination
     * Update a Switch Destination. (Access: admin)
     * @returns SwitchesDestinationsPostResponse Switch Destination updated.
     * @returns any Unexpected error
     * @throws ApiError
     */
    public updateSwitchDestination({
        id,
        requestBody,
    }: {
        /**
         * ID of the Switch Destination to update
         */
        id: switch_destination_id,
        /**
         * Switch Destination's information
         */
        requestBody: SwitchesDestinationsPutRequest,
    }): CancelablePromise<SwitchesDestinationsPostResponse | {
        code: number;
        message: string;
    }> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/switches/destinations/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Access token is missing or invalid`,
                409: `Conflict`,
                415: `Unsupported Media Type`,
            },
        });
    }
    /**
     * Delete a switch destination
     * Deletes a switch destination linked to contract. All the associated connections are destroyed. (Access: admin)
     * @returns any Unexpected error
     * @throws ApiError
     */
    public deleteSwitchDestinationById({
        id,
    }: {
        /**
         * ID of the switch destination to delete
         */
        id: switch_destination_id,
    }): CancelablePromise<{
        code: number;
        message: string;
    }> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/switches/destinations/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Access token is missing or invalid`,
                404: `Not found`,
            },
        });
    }
    /**
     * Get a list of Switch Destinations linked to a contract
     * Get a list of Switch Destinations linked to a contract. (Access: all)
     * @returns SwitchesDestinationsListResponse Switches list
     * @returns any Unexpected error
     * @throws ApiError
     */
    public getDestinationsList({
        requestBody,
    }: {
        requestBody: SwitchesDestinationsListRequest,
    }): CancelablePromise<SwitchesDestinationsListResponse | {
        code: number;
        message: string;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/switches/destinations/list',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Access token is missing or invalid`,
                404: `Not found`,
            },
        });
    }
}
